module.exports = __webpack_public_path__ + "static/media/activeAppointmentList.32cd9ad2.svg";